module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/question-12e0be8e1cc5b14f34989d93e1260a5f.svg";